export class ApiInfo {
    title: string;
    version: string;
    environment: string;
}
